export default __webpack_public_path__ + "static/media/workStep1.3c0bdb06.svg";